import { george, pr, theme } from "aaa";
import { ui } from "components/util/uiHelpers";
import { FormattedHTMLMessage } from "i18n/util";
import { observer } from "mobx-react";
import * as React from "react";
import externalInterfaceStore from "stores/ExternalInterfaceStore";
import { pushRoute } from "stores/RouterFunctions";
import { PocketsRoutes } from "./PocketsRoutes";
import { PocketsStore } from "./PocketsStore";

const labelStyle: React.CSSProperties = { wordBreak: "normal" };

export const PocketsSummary = observer(({ store }: { store: PocketsStore }) => {
    const PageComponent = externalInterfaceStore.isGeorgeApp ? george.PageWithActionButton : React.Fragment;

    const handleSubmit = async () => {
        try {
            await store.postPocketsActivation();
            pushRoute(PocketsRoutes.SIGNING);
        } catch (error) {
            pushRoute("/error");
        }
    };

    return (
        <george.Background>
            <PageComponent>
                <george.Card style={{ marginBottom: theme.MARGIN_SMALL }}>
                    <div style={{ padding: theme.MARGIN }}>
                        <george.SectionTitle style={{ marginTop: 0 }}>
                            {ui.__("common.summary")}
                        </george.SectionTitle>
                        <pr.LightSeparatorLine spacing={theme.MARGIN} />
                        <george.ResponsiveSummaryElement label={ui.__("signing.action.label")} labelStyle={labelStyle}>
                            <pr.SigningLabel>
                                {ui.__("pockets.summary.action.description")}
                            </pr.SigningLabel>
                        </george.ResponsiveSummaryElement>
                        <george.ResponsiveSummaryElement label={ui.__("signing.fee.label")} labelStyle={labelStyle}>
                            <pr.SigningLabel>
                                {ui.__("common.freeOfCharge")}
                            </pr.SigningLabel>
                        </george.ResponsiveSummaryElement>
                    </div>
                    {!externalInterfaceStore.isGeorgeApp &&
                        <pr.LightSeparatorLine spacing={theme.MARGIN} />
                    }
                    <george.ActionButton
                        messageId="loan.summary.actionSign"
                        onClick={handleSubmit}
                        isLoading={store.isLoading}
                        primary
                        {...george.getActionButtonWebVersionProps()}
                    />
                </george.Card>
            </PageComponent>
        </george.Background>
    );
});


// WEBPACK FOOTER //
// ./src/components/pockets/PocketsSummary.tsx